module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Dear Reader,")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c"
  }, [_c('span', [_vm._v("“Revenge is a dish best served cold.”")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The above line grabbed my attention the very first time I read it. Revenge is a strong, deep emotion—passion with a dark, sometimes bitter, side to it—and I have chosen it as the linking theme for my St. Fiacre’s books.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("I like the idea of my characters—all outwardly highly successful people—having a secret side to their natures. A side that can plot to avenge themselves, a side that might sometimes appall them, but that they are powerless to resist—for the darkest emotions are always the most irresistible....")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("What motivates revenge? It is always the sense of having been wronged, a chance to win after an earlier defeat. And like all deep, controlling passions, revenge has a knock-on effect.")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("But don’t take my word for it—find out yourself from Geraint, Triss and Dominic....")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text"
  }, [_c('img', {
    attrs: {
      "alt": "e9781459262027_i0002.jpg",
      "src": "e9781459262027_i0002.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5a51640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781459262027_fm02.vue
// module id = 63
// module chunks = 0